import i18n from "i18next"
import intervalPlural from "i18next-intervalplural-postprocessor"
import "moment/locale/de"
import { initReactI18next } from "react-i18next"

intervalPlural.setOptions({
  // these are the defaults
  intervalSeparator: ";",
  intervalRegex: /\((\S*)\).*?\[((.|\n)*)]/,
  intervalSuffix: "_plural",
})

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(intervalPlural)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      console.warn(`missing key '${key}'`)
    },
  })

export default i18n
